import React from 'react';
import { TextInput, SelectArrayInput, required, useTranslate } from 'react-admin';
import { Box, CircularProgress } from '@mui/material';
import { FormSection } from '@/components/shell';
import { useServerChoices } from '@/features/servers/useServerChoices';

/** The fields of a license, shared by its create and edit pages. */
export const LicenseFields: React.FC = () => {
  const t = useTranslate();
  const { choices: serverChoices, loading } = useServerChoices();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <FormSection title={t('screens.licenses.sectionLicense')}>
        <TextInput
          source="licenseName"
          label={t('resources.licenses.fields.licenseName')}
          validate={required()}
          fullWidth
        />
      </FormSection>
      <FormSection title={t('screens.licenses.sectionServers')}>
        <SelectArrayInput
          source="serverIds"
          label={t('resources.licenses.fields.servers')}
          choices={serverChoices}
          validate={required()}
          fullWidth
        />
      </FormSection>
    </>
  );
};
